import {observable, action, computed} from 'mobx';
import {objDeepCopy, isEmpty} from '../../utils/tool';
import NoticeService from '../../services/NoticeService';

class AssetChuzhiNoticeInstitution {
  condition = {};
  @observable chuzhiNoticeList = []; // 处置公告列表
  @observable chuzhiNoticePageNo = 1; // 处置公告列表分页
  @observable chuzhiNoticeListHasMore = true; // 处置公告列表加载中
  @observable vendorId = ''; // 商家Id
  @observable chuzhiNoticeTotalCount = 0; // 商家Id
  // 缓存数据初始化
  // 缓存数据来自 滚动事件 滚动高度 筛选条件 数据列表
  @action.bound
  chuzhiNoticeInitStore(allStatus) {
    for (let key in allStatus) {
      this[key] = allStatus[key];
    }
  }

  @action.bound
  saveCurrData(name, data) {
    this[name] = objDeepCopy(data);
  }
  @action.bound
  addCondition(condition) {
    for (let key in condition) {
      if (condition[key] == 'none') {
        delete this.condition[key];
        delete condition[key];
      }
    }

    this.resetChuzhiNoticeList();
    this.condition = Object.assign(this.condition, condition);
    this.getChuzhiNoticeList();
  }

  @action.bound
  resetCondition() {
    this.condition = {};
  }

  @action.bound
  resetChuzhiNoticeList() {
    this.chuzhiNoticeList = []; // 清空处置公告列表信息
    this.chuzhiNoticePageNo = 1; // 分页
    this.chuzhiNoticeListHasMore = true; // 列表加载
  }

  @action.bound
  getSelectionParams() {
    let promotionParams = {venderId: this.vendorId, pageNo: this.chuzhiNoticePageNo, pageSize: 10};
    if (isEmpty(this.condition)) {
      promotionParams = Object.assign(promotionParams);
    } else {
      promotionParams = Object.assign(promotionParams, this.condition);
    }
    return promotionParams
  }

  @action.bound
  getChuzhiNoticeList() {
    const chuzhiNoticeParams = this.getSelectionParams()
    // 处置公告列表
    return NoticeService.getChuzhiNoticeList(chuzhiNoticeParams).then(
      res => {
        let chuzhiNoticeList = [];
        if (res && res.data && res.data.length>0) {
          chuzhiNoticeList = res.data;
          this.chuzhiNoticeList.push(...chuzhiNoticeList);
          if (chuzhiNoticeList.length < 10) {
            this.chuzhiNoticeListHasMore = false;
          }
          this.chuzhiNoticePageNo += 1;
        } else {
          this.chuzhiNoticeListHasMore = false;
        }
        this.chuzhiNoticeTotalCount = res && res.totalItem ? res.totalItem : 0;
        return Promise.resolve();
      }
    ).catch(err => {
      console.log('getChuzhiNoticeList error:', err);
    })

  }

  setChuzhiNoticeListData = () => {
    sessionStorage.setItem('assetChuzhiNoticeIndex', JSON.stringify({
      chuzhiNoticePageNo: this.chuzhiNoticePageNo,
      chuzhiNoticeListHasMore: this.chuzhiNoticeListHasMore,
      chuzhiNoticeList: this.chuzhiNoticeList,
      condition: this.condition
    }))
  }
}

let assetChuzhiNoticeInstitution = new AssetChuzhiNoticeInstitution();

export default assetChuzhiNoticeInstitution;
